module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_empty", [["div",{"id":"container"}]]);
fox.registerTemplate("layout_servicemessage", [["div",{"id":"service-container"}]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/templates/layout/empty.tpl
// module id = 247
// module chunks = 2